module.exports = __webpack_public_path__ + "img/1-2.83e9993c.png";